/* Lightweight fire-and-forget funnel event tracker.
 *
 * Used by landing-page CTAs, register page, and the plan picker so we can
 * measure conversion lift on social-proof / pricing experiments without
 * pulling in a full analytics SDK.
 *
 * All calls are non-blocking — analytics never break the user flow.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

export function trackFunnel(event, props = {}) {
  if (!event) return;
  try {
    // navigator.sendBeacon survives page navigations (the common case here:
    // user clicks "Choose Pro" → we want to record it before the next page
    // loads). Falls back to fetch w/ keepalive when sendBeacon is missing.
    const url = `${API_URL}/api/funnel/event`;
    const body = JSON.stringify({ event, ...props });
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      credentials: 'include',
      keepalive: true,
    }).catch(() => { /* swallow */ });
  } catch { /* swallow */ }
}
